import { Title } from "@mantine/core"
import { UseQueryResult } from "@tanstack/react-query"
import { Card } from "@tfg/ui"

import { DataFetchWrapper } from "~/components/DataFetchWrapper"

type Props<TData, TError> = {
  query: UseQueryResult<TData, TError>
  children: (props: { data: TData }) => JSX.Element
  title: string
}

export const DashboardElement = <TData, TError>({
  query,
  children,
  title,
}: Props<TData, TError>) => {
  return (
    <Card>
      <Card.Header>
        <Title order={3}>{title}</Title>
      </Card.Header>
      <Card.Section>
        <DataFetchWrapper query={query}>{children}</DataFetchWrapper>
      </Card.Section>
    </Card>
  )
}
